import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, mergeMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { HistoryLogBaselineActions } from './history-log-baseline.actions';
import { HistoryLogBaselineService } from '../../service/history-log-baseline.service';


@Injectable()
export class HistoryLogBaselineEffects {
loadBaselineHistoryLog$ = createEffect(
        (rs: HistoryLogBaselineService = inject(HistoryLogBaselineService)) => {
            return this.actions$.pipe(

                ofType(HistoryLogBaselineActions.loadBaselineHistoryLog),
                mergeMap(({ parameters, legalEntityId, campaignId }) =>
                    rs.fetchBaselineHistoryLog(parameters, legalEntityId, campaignId).pipe(
                        map((historyLog) => {
                            return HistoryLogBaselineActions.loadBaselineHistoryLogSuccess({
                                historyLog
                            });
                        }),
                        catchError((error) => of(HistoryLogBaselineActions.loadBaselineHistoryLogFailure({ error })))
                    )
                )
            );
        },
        { functional: true }
    );

    constructor(private actions$: Actions) { }
}
